/* global jQuery, _ */

(function ($) {
  window.atex = window.atex || {};
  window.atex.aceui = window.atex.aceui || {};
  window.atex.aceui.service = window.atex.aceui.service || {};

  atex.aceui.service.LocalizationService = (localizationServiceUrl, serviceSettings) => {
    var q = serviceSettings.customQ || window.Q;

    return {
      getLocalization: ({ localizationContexts, languageKey }) => {
        var deferred = q.defer();

        let localizationContextsPath = encodeURIComponent(localizationContexts.join('|'));
        var fullUrl = localizationServiceUrl + `/${localizationContextsPath}/${languageKey}`;

        if (serviceSettings.cacheBusting === true) {
          fullUrl = fullUrl + '&cacheBusting=' + Math.random().toString().substring(2);
        }

        $.ajax(fullUrl, {
          dataType: 'json',

          success: (data, textStatus, jqXHR) => {
            var eTag = jqXHR.getResponseHeader('ETag');
            deferred.resolve(data);
          },

          error: (jqXHR, textStatus, errorThrown) => {
            var e = atex.aceui.HTTPUtils.createError(jqXHR, 'atex.aceui.service.LocalizationService', {
              401: `Could not authenticate user while getting translation map for ${languageKey}`,
              403: `Permission denied when getting translation map for ${languageKey}`,
              404: `A translation map for translation map for ${languageKey}`,
              'default': `There was an error while getting translation map for ${languageKey}`
            });

            if (typeof e.rootCause !== 'undefined') {
              e.rootCause.textStatus = textStatus;
              e.rootCause.errorThrown = errorThrown;
              e.rootCause.requestArgs = { localizationContextsPath, languageKey };
            }

            deferred.reject(e);
          }
        });
        return deferred.promise;
      }
    };
  };
})(jQuery);
